<!--
    课程统计-授权统计
    功能：展示校区授权课程的统计数据、查看授权账号信息、导出搜索数据
    说明：版本3.0
-->
<template>
  <div
    v-loading="isLoading"
    class="auth-page">
    <div
      ref="top"
      class="top-demo">
      <search-form
        :is-query.sync="listQuery"
        :form-data="formData"
        :is-add="false"
        :is-search="true"
        style="flex:1"
        @onSearch="handlerSearch"/>
      <div class="btn-block">
        <el-button
          :loading="downLoading"
          size="medium"
          type="primary"
          @click="handlerExcel">导出搜索数据</el-button>
      </div>
    </div>
    <el-table
      v-if="tableHeight"
      ref="table"
      :data="tableData"
      :height="tableHeight"
      class="table-demo"
      fit
      style="width: 100%;"
    >
      <el-table-column
        v-for="item in tableHead"
        :key="item.id"
        :label="item.label"
        :width="item.width"
        :min-width="item.minWidth"
        :prop="item.prop"
        :formatter="item.formatter"
      />
      <el-table-column
        label="授权状态"
        width="100px"
        align="center"
      >
        <template slot-scope="{row}">
          <span :class="authClass[row.auth_status]">{{ authType[row.auth_status] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="授权账号数/账号数"
        width="100px"
        align="center"
      >
        <template slot-scope="{row}">
          <el-link
            size="small"
            @click="authInfo(row)">
          <span style="color:red">{{ filterUserCount(row).length }}</span>/{{ row.users.length }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        v-for="item in tableHead2"
        :key="item.id"
        :label="item.label"
        :width="item.width"
        :min-width="item.minWidth"
        :prop="item.prop"
        :formatter="item.formatter"
      />
      <el-table-column
        label="操作"
        width="100px"
        fixed="right"
        align="center"
      >
        <template slot-scope="{row}">
          <el-link
            v-if="row.auth_status===1"
            size="small"
            @click="closeAuth(row)"
          >取消授权</el-link>
          <el-link
            v-else
            type="info"
            disabled
            size="small"
          >已取消</el-link>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="total"
      :current-page.sync="listQuery.page"
      :page-size="parseInt(listQuery.per_page)"
      :total="total"
      background
      layout="prev, pager, next"
      style="text-align: right;margin-top:20px"
      @current-change="getList"
    />
    <users-info-dialog
      v-if="showUserInfo"
      :visible.sync="showUserInfo"
      :cur-row="curRow"
      @refresh="getList"/>
  </div>
</template>
<script>
import { tableHead, tableHead2, formData } from './fields';
import { fetchAuthStatics, downAuthStatics, closeAuthPacket } from '@/api/courseStatistics';
import searchForm from '@/components/AppFilter';
import usersInfoDialog from './usersInfoDialog.vue';

export default {
  name: 'AuthorityStatistics',
  components: {
    searchForm,
    usersInfoDialog,
  },
  data() {
    return {
      total: 0, // 分页总页数
      isLoading: false, // 是否加载
      tableData: [],
      tableHeight: null,
      listQuery: {
        page: 1,
        per_page: 10,
      },
      tableHead,
      tableHead2,
      formData,
      dateVal: null,
      showUserInfo: false,
      authType: {
        0: '未授权',
        1: '已授权',
        2: '取消授权',
      },
      authClass: {
        0: 'text-info',
        1: 'text-success',
        2: 'text-danger',
      },
      curRow: {},
      downLoading: false,
    };
  },
  mounted() {
    this.setTableHeight();
    this.getList();
    window.onresize = () => {
      setTimeout(() => {
        this.setTableHeight();
      }, 10);
    };
  },
  methods: {
    setTableHeight() {
      this.tableHeight = window.innerHeight - this.$refs.top.offsetHeight - 120;
    },
    getList() {
      this.isLoading = true;
      fetchAuthStatics(this.dateVal, this.$store.state.choicesSchool.id, this.listQuery).then((res) => {
        this.tableData = res.items;
        this.total = res.meta.total;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    closeAuth(row) {
      this.$confirm('该操作将<strong style="color:red">取消授权</strong>，是否继续?', '提示', {
        dangerouslyUseHTMLString: true,
        showCancelButton: true,
        type: 'warning',
        confirmButtonText: '确定',
        confirmButtonClass: 'el-button',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            const obj = {
              auth_record_id: row.id,
            };
            if (row.auth_type === 1) { // 按账号
              const auth_record_user_list = [];
              row.users.forEach((item) => {
                auth_record_user_list.push({
                  id: item.id,
                });
              });
              obj.auth_record_user_list = auth_record_user_list;
            }
            closeAuthPacket(row.auth_type, this.$store.state.choicesSchool.id, obj).then((res) => {
              if (res.status_code === 200) {
                this.$message.success('操作成功！');
                this.getList();
              } else {
                this.$message.error(res.message);
              }
            }).finally(() => {
              done();
              instance.confirmButtonLoading = false;
            });
          } else {
            done();
          }
        },
      }).catch(() => {

      });
    },
    authInfo(row) {
      if (row.auth_status) {
        this.curRow = Object.assign(row);
        this.showUserInfo = true;
      }
    },
    // 账号数
    filterUserCount(row) {
      const newArr = [];
      row.users.forEach((item) => {
        if (item.auth_status === 1) {
          newArr.push(item);
        }
      });
      return newArr;
    },
    handlerExcel() {
      this.downLoading = true;
      downAuthStatics(this.dateVal, this.$store.state.choicesSchool.id, this.listQuery).then((res) => {
        this.downLoading = false;
        this.$setting.saveAs(res, '授权统计');
      });
    },
    handlerSearch(date) {
      this.dateVal = date;
      this.listQuery.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.auth-page{
  height: 100vh;
  width: 100%;
  flex:none!important;
  box-sizing: border-box;
}
.top-demo{
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .btn-block{
    width: 300px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseStatistics/AuthorityStatistics/index.vue